import React, { useRef, useCallback, } from 'react'
import List from '../../grid.component';
import { AddresssHandler, CreditHandler, DateHandler, TransactionHash } from '../service';
import { useParams } from 'react-router-dom';


const EnergyTransactionsGrid = ((props) => {
    const gridRef = useRef(null);
    const { tenantId } = useParams()
    const handleHash = useCallback((data) => () => {
    window.open(data.url)
  }, [])
  const energyTransactionHandler = useCallback((data) => {
    return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
  }, [])
  const addressHandler = useCallback((data) => {
    return <AddresssHandler data={data?.dataItem} />
  }, [])
  const creditHandler = useCallback((data) => {
    return <CreditHandler data={data?.dataItem} />
  }, [])
  const dateHandler = useCallback((data) => {
    return <DateHandler data={data?.dataItem} />
  }, [])
  const gridColumns = [
    {
      "field": "address",
      "title": "Address",
      "filter": true,
      "customCell": addressHandler,
      "width": 200,
    },
    {
      "field": "credits",
      "title": "Credit Used",
      "customCell": creditHandler,
      "filter": true,
      "width": 150,
      "filterType": "numeric"
    },
    {
      "field": "transactionhash",
      "title": "Transaction Hash",
      "filter": true,
      "customCell": energyTransactionHandler,
      "width": 200,
    },
    {
      "field": "date",
      "title": "Date/Time",
      "filter": true,
      "width": 200,
      "filterType": "date",
      "customCell": dateHandler,
    }
  ]

    return (
        <div>
            <List
                url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/transactions/${tenantId}`}
                pSize={10}
                additionalParams={props?.filterValues}
                gridRef={gridRef}
                className="custom-grid"
                columns={gridColumns}
                showExcelExport={props?.isExcelExport}
                pKey={"Energy_Recharge_Transactions"}
            />
        </div>
    )
})

export default React.memo(EnergyTransactionsGrid)
